module.exports = __webpack_public_path__ + "img/logo.313975df.svg";